import { css, cx } from "@emotion/css";
import { mergeProps } from "react-aria";
import { ComboBox as AriaComboBox, ComboBoxProps } from "react-aria-components";

import { sharedStyles } from "../../styles";

export function _ComboBox<T extends object>(props: ComboBoxProps<T>) {
  return (
    <AriaComboBox
      {...mergeProps(props, {
        className: cx(sharedStyles.field, styles.combobox),
      })}
    />
  );
}

const styles = {
  combobox: css({
    "> button": css(sharedStyles.input, {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }),
    "&[data-invalid] > button": css({
      boxShadow: `inset 0 0 0 1px var(--border-danger-input)`,
      "&[data-focused]": {
        boxShadow: "var(--focus-input-error)",
      },
    }),
  }),
};
